<template>
    <div data-cy="container_store_count_control">
        <button class="bg-gray-300 text-white font-bold py-0 px-4 rounded-sm mr-3" @click="decrease()" data-cy="btn_store_count_control_decrease">-</button>
        <button class="bg-gray-300 text-white font-bold py-0 px-4 rounded-sm mr-3" @click="increase()" data-cy="btn_store_count_control_increase">+</button>
    </div>
</template>
<script>
export default {
    name: "StoreCountControl",
    inject: ["CountStore"],
    methods: {
        increase: function() {
            this.CountStore.methods.increase();
        },
        decrease: function() {
            this.CountStore.methods.decrease();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
